import Factor from "./Factor";

export default Factor;
